import { createFileRoute } from "@tanstack/react-router";
import { LocationPageLayout } from "@/components/location/LocationPageLayout";
import { locationHead } from "@/lib/location-head";
import { loadPageSeo } from "@/lib/page-seo-loader";

const SLUG = "north-phoenix-roofing";

export const Route = createFileRoute("/north-phoenix-roofing")({
  loader: () => loadPageSeo(SLUG),
  head: ({ loaderData }) => locationHead(SLUG, loaderData),
  component: Page,
});

function Page() {
  return <LocationPageLayout slug={SLUG} />;
}
